(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/divider/assets/javascripts/divider.js') >= 0) return;  svs.modules.push('/components/content/divider/assets/javascripts/divider.js'); "use strict";


(function (window, svs, gsap) {
  'use strict';

  svs.content = svs.content || {};

  svs.content.Divider = function () {
    $('.js-divider-btn').on('click', dividerLink);
    $('.divider-text').find('a').click(function (e) {
      e.preventDefault();
      var areaName = $(e.currentTarget.parentElement).data('area-name'),
          track = "divider-link-".concat(svs.utils.url.encode(e.currentTarget.text)),
          url = e.currentTarget.href;

      if (areaName && track && url) {
        svs.components.analytics.trackPromoClick({
          id: track,
          name: track,
          position: areaName
        }, function () {
          window.location.href = url;
        });
      } else {
        window.location.href = url;
      }
    });
    var brands, brandsAnimationStarted;

    function calculateBrands() {
      brands.forEach(function (item) {
        $(item).css('transform', 'none');
        var ghost = $(".divider-ghost-brands > .brand[data-brand=\"".concat($(item).data('brand'), "\"]"));
        item.initPosition = ghost[0].getBoundingClientRect();
        item.endPosition = item.getBoundingClientRect();
        item.randomEnd = Math.round(Math.random() * 100);
        item.fromY = item.initPosition.top - item.endPosition.top;
        item.fromX = item.initPosition.left - item.endPosition.left;
        item.fromOffsetY = item.fromY + Math.floor(Math.random() * 51) - 25;
        item.fromOffsetX = item.fromX + Math.floor(Math.random() * 51) - 25;
        item.fromRotate = Math.floor(Math.random() * 51) - 25;
        item.deltaW = item.initPosition.width / item.endPosition.width;
        item.deltaH = item.initPosition.height / item.endPosition.height;
        $(item).css('transform', "translate3d(".concat(item.fromX, "px,").concat(item.fromY, "px, 0)"));
      });
    }

    function getTiming(min, max) {
      min *= 10;
      max *= 10;
      var val = Math.floor(Math.random() * (max - min + 1)) + min;
      return val / 10;
    }

    function animate(_baseDelay) {
      $('.divider-content-brands').css('visibility', 'visible');
      $('.divider-ghost-brands').css('display', 'none');
      var baseDuration = 0.4,
          baseDelay = _baseDelay ? _baseDelay : 0; 

      var brandsDuration = 0; 

      brandsAnimationStarted = true;
      brands.forEach(function (item) {
        var delay = getTiming(baseDelay, baseDelay + 0.3),
            bduration = getTiming(baseDuration, baseDuration + 0.5),
            easing = getTiming(0.2, 0.6);
        brandsDuration = brandsDuration < delay + bduration ? delay + bduration : brandsDuration;
        brandsDuration = Math.round(brandsDuration * 100) / 100;
        gsap.fromTo(item, {
          duration: bduration,
          x: item.fromX,
          y: item.fromY
        }, {
          x: 0,
          y: 0,
          ease: "back.out(".concat(easing, ")"),
          delay: delay
        });
      }); 

      var slideDownItems = [$('.divider-content-sport .divider-content-button'), $('.divider-content-tur .divider-content-button')];
      slideDownItems.forEach(function (item, i) {
        gsap.fromTo(item, {
          duration: 0.2,
          y: -20,
          autoAlpha: 0
        }, {
          y: 0,
          autoAlpha: 1,
          delay: brandsDuration - 0.8 + i * 0.1
        });
      });
      var slideUpItems = [$('.divider-content-sport .divider-content-text'), $('.divider-content-tur .divider-content-text')];
      slideUpItems.forEach(function (item, i) {
        gsap.fromTo(item, {
          duration: 0.2,
          y: 20,
          autoAlpha: 0
        }, {
          y: 0,
          autoAlpha: 1,
          delay: brandsDuration - 0.8 + i * 0.1
        });
      });
      var backgroundItems = [$('.divider-content-sport .divider-content-background'), $('.divider-content-tur .divider-content-background')]; 

      backgroundItems.forEach(function (item, i) {
        gsap.to(item, {
          duration: 0.4,
          autoAlpha: 1,
          y: 0,
          delay: brandsDuration - 1 + i * 0.1
        });
      });
    }

    function play(delay) {
      var d = delay ? delay : 400;
      animate(d / 1000);
    }

    function init() {
      brands = $('.divider-content').find('.brand').toArray(); 

      var resizeTimer;
      window.addEventListener('resize', function () {
        resizeTimer = setTimeout(function () {
          if (!brandsAnimationStarted) {
            calculateBrands();
          }

          clearTimeout(resizeTimer);
        }, 100);
      }, false); 

      calculateBrands();

      if (svs.components && svs.components.cookies_check_and_info) {
        if (svs.components.cookies_check_and_info.dataHandler.getShowCookieInfo()) {
          svs.events.subscribe('hideOverlay', function () {
            play(500);
          });
        } else {
          play();
        }
      } else {
        play();
      }
    }

    return {
      init: init
    };
  };

  svs.content.divider = new svs.content.Divider();

  function trackClick(el, callback) {
    var $el = $(el),
        track = $el.data('track'),
        areaName = $el.data('areaName') || 'unknown';

    if (track) {
      svs.components.analytics.trackPromoClick({
        id: track,
        name: track,
        position: areaName
      }, callback);
    }
  }

  function dividerLink(e) {
    e.preventDefault();
    var url = $(this).attr('href');
    trackClick(this, function () {
      window.location.href = url;
    });
  }
})(window, svs, gsap);
 })(window);